import { AgTechAppLoadingRetryConfiguration } from '@agtech/core/functions/AgTechAppLoading'
import { AgTechButton } from '../Buttons/AgTechButtons'
import { AgTechErrorIcon } from '../Icons/AgTechIcons'
import React from 'react'
import { isDev } from '@agtech/core/utilities/AgTechUtilities'

export type AgTechErrorMessageProps = {
    errorMessage: string
    retryConfiguration?: AgTechAppLoadingRetryConfiguration,
    error?: any
}

const AgTechErrorMessage = (props: AgTechErrorMessageProps) => {    
    return (
        <div className="stretched row-based centered container">
            <AgTechErrorIcon
                size={36}
                classes='mb-4'
            />
            <h1 className='text-md font-semibold mb-6'>{props.errorMessage}</h1>
            {props.retryConfiguration ? (
                <AgTechButton
                    text={props.retryConfiguration.retryButtonText}
                    icon={props.retryConfiguration.retryIconText}
                    action={props.retryConfiguration.retryAction}
                    classes='mt-6 rounded button-highlight'
                />
            ) : null}
        </div>
    )
}

export default AgTechErrorMessage